angular.module('components.media.ImageService', [
  'global'
])

/**
 * The ImageService service handles scoring and
 * feedback for the state.contentView type
 *
 * @class ImageService
 * @constructor
 * @module components.media.ImageService
 */
.factory('ImageService', [
  function () {
    'use strict';

    return {};
  }
]);
